export const getReverseSortDirection = (currentDirection: string) =>
  currentDirection === "asc" ? "desc" : "asc";
